// extracted by mini-css-extract-plugin
export var howWeWorkDescUpper = "howWeWorkDesc-module--howWeWorkDescUpper--6dKep";
export var howWeWorkDescPoints = "howWeWorkDesc-module--howWeWorkDescPoints--KxCAd";
export var howWeWorkDescPoint = "howWeWorkDesc-module--howWeWorkDescPoint--NMrKu";